<!--<template>-->
<!--<div>-->
<!--  开票管理-&#45;&#45;开票记录页面-->
<!--  <button @click="jump">详情</button>-->
<!--</div>-->

<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: "InvoiceRecord",-->
<!--  methods:{-->
<!--    jump(){-->
<!--      this.$router.push('/Financial/InvoiceManage/InvoiceRecordDetail')-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->

<!--</style>-->
<template>
  <div class="page">
    <!--    导出  Export    导入物流信息 importLogisticsInfo-->
    <!--    订单详情   orderDetail-->
    <div class="form-box">
      <el-form @submit.native.prevent label-width="100px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="分销商:">
              <el-input v-model="searchData.resllerName" placeholder="请输入分销商名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开票批次号:">
              <el-input v-model="searchData.BatchNo" placeholder="请输入开票批次号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对账周期：">
              <el-date-picker :default-time="['00:00:00', '23:59:59']" v-model="valueTime" type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                @change="handlePicker" class="w100"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <div class="flex">
            <el-button type="primary" @click="searchFun">筛选</el-button>
            <el-button @click="resetFun">重置</el-button>
            <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row v-loading="listLoading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" fixed align="center"></el-table-column>
      <el-table-column prop="billingBatchNo" label="开票批次号" align="center">

      </el-table-column>
      <el-table-column width="150" prop="resellerName" label="分销商" align="center">

      </el-table-column>
      <el-table-column width="120" prop="billingAmount" label="开票金额" align="center">

      </el-table-column>
      <el-table-column label="开票信息" width="300">
        <template slot-scope="scope">
          <div>
            <p>发票类型:{{ scope.row.invoiceType }}</p>
            <p>抬头:{{ scope.row.invoiceRise }}</p>
            <p>纳税人识别号:{{ scope.row.taxpayerNumber }}</p>
            <p>地址:{{ scope.row.invoiceAddress }}</p>
            <p>开户行:{{ scope.row.invoiceBank }}</p>
            <p>银行账户:{{ scope.row.invoiceBankAccount }}</p>
            <p>电话:{{ scope.row.invoiceMobile }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="creationTime" label="开票时间" align="center">

      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
    </el-pagination>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderExport,
  OrderLogisticUpload, FinanceBillingGetAll,
  GetBillingOrders
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  name: "InvoiceRecord",
  components: { Toolbar },
  data() {
    return {
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [{ 'id': 1 }],
      productNavTypeTreeList: [],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        BillingStartTime: null,
        BillingEndTime: null,
        resllerName: '',
        BatchNo: ''
      },
      value: '',
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
    };
  },
  created() {
    // if (this.$route.query.id) {
    // this.distributorId = this.$route.query.id;
    // this.searchData.Id = this.$route.query.id;
    // this.form.resellerId = this.$route.query.id;
    // // this.orderId = this.$route.query.orderId;
    // console.log('---+++++++--', this.distributorId) ;
    // // this.getDetail(this.$route.query.Id)
    this.getTableList();
    // } else {
    //   return this.$message.error('供应商Id,参数缺失')
    // }
    // this.getProductNavTypeTree();
    // this.getBrandList();
    // this.getTableList();
  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    export() {
      console.log('exp')
    },
    InvoiceRecordDetails(button, index, row) {
      this.$router.push(`/Financial/InvoiceManage/InvoiceRecordDetail?id=${row.id}`)
    },
    MakingInvoice() {
      alert('锤子')
    },
    dealerDetail() {
      this.$router.push('/Financial/DealerFinancialManage/Detail')
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    orderDetail(button, index, row) {
      // this.$router.push(
      //   `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`
      // );
    },
    async getTableList(searchData) {
      this.loading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await FinanceBillingGetAll(this.searchData);
      if (res.data.success) {
        console.log('++++++++++++++', res);
        this.listLoading = false;
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.msg)
      }
      console.log('已收货', res);
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.searchData.PageIndex = 1;
      this.getTableList();
    },
    handlePicker(date) {
      if (date == null) {
        this.valueTime = []
        this.searchData.BillingStartTime = null
        this.searchData.BillingEndTime = null
      } else {
        this.searchData.BillingStartTime = date[0]
        this.searchData.BillingEndTime = date[1]
      }
    },
    resetFun() {
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        BillingStartTime: null,
        BillingEndTime: null,
        resllerName: '',
        BatchNo: ''
      };
      this.valueTime = [];
      this.getTableList();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      this.listLoading = false;
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


